import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, TrendingDownIcon, GlobeIcon, ShieldAlertIcon, SearchXIcon } from 'lucide-react';
const frustrations = [{
  icon: TrendingDownIcon,
  text: 'Sigues en la carrera de la rata: cada aumento de sueldo se evapora con la subida del dólar.'
}, {
  icon: AlertCircleIcon,
  text: 'Miras el precio de cualquier producto importado y sientes que trabajas para sobrevivir, no para vivir bien.'
}, {
  icon: GlobeIcon,
  text: 'Te gustaría ganar en dólares, pero te asusta no saber inglés o no tener un título internacional.'
}, {
  icon: ShieldAlertIcon,
  text: 'Sientes que hay una barrera invisible entre tú y los que ganan en moneda fuerte.'
}, {
  icon: SearchXIcon,
  text: 'Has intentado buscar opciones online pero todo parece una estafa o requiere habilidades que no tienes.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function IdentificationSection() {
  return <section className="py-24 px-4 bg-[#0A0A0A]" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-21">
            ¿Te Identificas Con{' '}
            <span className="text-[#C9A84C]" data-id="element-22">Algo de Esto?</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-23">
          {frustrations.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-4 p-6 rounded-xl bg-[#0f0f0f] border border-neutral-800 hover:border-[#1A7A4A]/30 transition-colors group" data-id="element-24">
              <div className="flex-shrink-0 mt-1" data-id="element-25">
                <item.icon className="w-6 h-6 text-[#C9A84C] group-hover:text-[#1A7A4A] transition-colors" data-id="element-26" />
              </div>
              <p className="text-lg text-[#D1D5DB] leading-relaxed" data-id="element-27">
                {item.text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}